import { fetchSectionChallengeTopicBlueprints } from "@/store/appData/appDataActions";
import Cookie from "js-cookie";
import moment from "moment";
import { toastI18n } from "@/components/common/Toast";
import { request } from "@/utils/api/legacyRequest";
import { SET_USER_LOADED } from "../metadata/metadataActions";
import i18n from "../../i18n";
import { setSentryUser } from "@/sentry";
import { API_PUT } from "@/store/middleware/middlewareConstants";
import { BACKEND_URI } from "@/config";

// ACTION TYPES
export const SET_USER = "SET_USER";
export const SET_JWT = "SET_JWT";
export const SET_USER_ID = "SET_USER_ID";
export const SET_EMAIL = "SET_EMAIL";

// ACTION CREATORS
export function setUser(data) {
  if (data) {
    setSentryUser({
      id: data.id,
      email: data.email_address,
      username: data.username,
    });
  }
  return {
    type: SET_USER,
    data,
  };
}

export const SET_USER_CONSENT = "user/SET_USER_CONSENT";
export function fetchUserConsent(jwt) {
  return (dispatch) => {
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/accounts/user-consents`;
    return request(url, jwt).then((response) => {
      dispatch({ type: SET_USER_CONSENT, data: response.data });
      dispatch({ type: SET_USER_LOADED });
    });
  };
}

export function fetchUser() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");

    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/settings/users`;
    return request(url, jwt)
      .then((response) => {
        dispatch(fetchUserConsent(jwt));
        dispatch(setUser(response.data[0]));
      })
      .catch(() => {
        return Promise.reject();
      });
  };
}

export const SET_USER_PREFERENCE = "user/SET_USER_PREFERENCE";
export function getUserPreference() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/accounts/preferences/${user.get("id")}`;
    if (jwt) {
      return request(url, jwt).then((response) => {
        dispatch({
          type: SET_USER_PREFERENCE,
          data: response.data || { language: Cookie.get("userPreference") },
        });

        if (response.data === "ESP" || Cookie.get("userPreference") === "ESP") {
          i18n.changeLanguage("es");
        } else {
          i18n.changeLanguage("en");
        }
      });
    }
    dispatch({
      type: SET_USER_PREFERENCE,
      data: { language: Cookie.get("userPreference") },
    });
    if (Cookie.get("userPreference") === "ESP") i18n.changeLanguage("es");
    else i18n.changeLanguage("en");
    return "";
  };
}

export function schedulerPreferencesSaved(data) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_PREFERENCE,
      data,
    });
    dispatch(toastI18n("success", "EmailSettingsSaved"));
  };
}

/**
 * Still a thunk rather than a plain action object: the URL needs the user id,
 * which only `getState` has. The dispatched action is an `API_PUT`, so this
 * feeds `state.metadata.isRequesting` (which the settings footers read as
 * their `isSaving` signal) and routes failures through the middleware's shared
 * error path instead of throwing unhandled.
 */
export function setSchedulerPreferences(
  alertsEmailInterval,
  hubActivityEmailInterval
) {
  return (dispatch, getState) => {
    const { user } = getState();
    const token = Cookie.get("token");

    return dispatch({
      type: API_PUT,
      payload: {
        url: `${BACKEND_URI}/api/accounts/preferences/${user.get("id")}`,
        body: {
          preference: {
            alerts_email_interval: alertsEmailInterval,
            hub_activity_email_interval: hubActivityEmailInterval,
          },
        },
        success: schedulerPreferencesSaved,
        onSuccess: null,
        token: token !== undefined ? token : null,
      },
    });
  };
}

export function setUserPreference(language) {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/accounts/preferences/${user.get("id")}`;

    const payload = {
      preference: {
        language,
      },
    };

    Cookie.set("userPreference", language, { expires: 30 });

    if (language === "ESP") {
      moment.locale("es");
      Cookie.set("dateFormat", "D[,] MMMM YYYY", { expires: 30 });
      i18n.changeLanguage("es");
    } else if (language === "ENG") {
      moment.locale("en_US");
      Cookie.set("dateFormat", "MMMM D[,] YYYY", { expires: 30 });
      i18n.changeLanguage("en");
    }

    if (jwt) {
      return request(url, jwt, "PUT", payload).then((response) => {
        dispatch({
          type: SET_USER_PREFERENCE,
          data: response.data || { language: Cookie.get("userPreference") },
        });
        dispatch(fetchSectionChallengeTopicBlueprints());
      });
    }
    dispatch({
      type: SET_USER_PREFERENCE,
      data: { language: Cookie.get("userPreference") },
    });
    return "";
  };
}
